import { createFromToArray } from 'ml-spectra-processing';
import { SubFlagParameters } from './utility';
/**
 * Parses the subheader (header of the subfile)
 *
 * @param buffer SPC buffer.
 * @return subheader object
 */
export class SubHeader {
    constructor(buffer) {
        this.parameters = new SubFlagParameters(buffer.readUint8());
        this.exponentY = buffer.readInt8();
        this.indexNumber = buffer.readUint16();
        this.startingZ = buffer.readFloat32();
        this.endingZ = buffer.readFloat32();
        this.noiseValue = buffer.readFloat32();
        this.numberPoints = buffer.readUint32();
        this.numberCoAddedScans = buffer.readUint32();
        this.wAxisValue = buffer.readFloat32();
        this.reserved = buffer.readChars(4).replace(/\x00/g, '').trim();
    }
}
/**
 * Reads a file's data block (old SPC format)
 *
 * @param buffer spc buffer.
 * @param fileHeader header.
 * @return Array containing the spectra.
 */
export function oldDataBlock(buffer, fileHeader) {
    // either Y or YY fall on the for loop
    let spectra = [];
    // old format uses always equidistant arrays
    const x = createFromToArray({
        from: fileHeader.startingX,
        to: fileHeader.endingX,
        length: fileHeader.numberPoints,
    });
    for (let i = 0; buffer.offset + fileHeader.numberPoints < buffer.length; i++) {
        const subFileHeader = new SubHeader(buffer);
        const y = getOldY(new Float64Array(x.length), subFileHeader, fileHeader, buffer);
        const variables = setXYAxis(x, y, fileHeader);
        spectra.push({ meta: subFileHeader, variables });
    }
    return spectra;
}
/**
 *
 *
 * @export
 * @param {Float64Array} y
 * @param {SubHeader} subHeader
 * @param {TheOldHeader} fileHeader
 * @param {IOBuffer} buffer
 * @return {*}
 */
export function getOldY(y, subHeader, fileHeader, buffer) {
    const { fileVersion, exponentY, parameters: { y16BitPrecision }, } = fileHeader;
    if (subHeader.exponentY === 0) {
        subHeader.exponentY = exponentY;
    }
    const yFactor = Math.pow(2, subHeader.exponentY - (y16BitPrecision ? 16 : 32));
    if (y16BitPrecision) {
        for (let j = 0; j < y.length; j++) {
            y[j] = buffer.readInt16() * yFactor;
        }
    }
    else {
        for (let j = 0; j < y.length; j++) {
            if (fileVersion === 0x4d) {
                y[j] =
                    ((buffer.readUint8() << 16) +
                        (buffer.readInt8() << 24) +
                        (buffer.readUint8() << 0) +
                        (buffer.readUint8() << 8)) *
                        yFactor;
            }
        }
    }
    return y;
}
/**
 *
 *
 * @export
 * @param {Float64Array} x
 * @param {Float64Array} y
 * @param {Header} fileHeader
 * @return {*}
 */
export function setXYAxis(x, y, fileHeader) {
    var _a, _b, _c, _d;
    const xAxis = /(?<label>.*?) ?[([](?<units>.*)[)\]]/.exec(fileHeader.xUnitsType);
    const yAxis = /(?<label>.*?) ?[([](?<units>.*)[)\]]/.exec(fileHeader.yUnitsType);
    const variables = {
        x: {
            symbol: 'x',
            label: ((_a = xAxis === null || xAxis === void 0 ? void 0 : xAxis.groups) === null || _a === void 0 ? void 0 : _a.label) || fileHeader.xUnitsType,
            units: ((_b = xAxis === null || xAxis === void 0 ? void 0 : xAxis.groups) === null || _b === void 0 ? void 0 : _b.units) || '',
            data: x,
            isDependent: false,
        },
        y: {
            symbol: 'y',
            label: ((_c = yAxis === null || yAxis === void 0 ? void 0 : yAxis.groups) === null || _c === void 0 ? void 0 : _c.label) || fileHeader.yUnitsType,
            units: ((_d = yAxis === null || yAxis === void 0 ? void 0 : yAxis.groups) === null || _d === void 0 ? void 0 : _d.units) || '',
            data: y,
            isDependent: true,
        },
    };
    return variables;
}
//# sourceMappingURL=oldDataBlock.js.map